import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function CCTVSetup() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>CCTV & Surveillance</h1>
        <p>Design, install and maintain robust CCTV systems for any environment.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Capabilities</h3>
          <ul>
            <li>Camera selection & placement</li>
            <li>NVR/DVR and cloud recording solutions</li>
            <li>Monitoring and analytics integration</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/contact">Request CCTV Quote</a>
        </div>
      </div>
    </div>
  );
}

export default CCTVSetup;
